module.exports = __webpack_public_path__ + "static/media/phone_wait.3cf4e552.svg";